'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OutfeatAdminDecorator = function OutfeatAdminDecorator(_ref) {
  var isPrivate = _ref.isPrivate;
  var onClick = _ref.onClick;
  var children = _ref.children;
  return _react2.default.createElement(
    'div',
    { classNames: 'container' },
    children,
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'button',
        { onClick: onClick },
        isPrivate ? 'Set public' : 'Set private'
      )
    )
  );
};

exports.default = OutfeatAdminDecorator;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/OutfeatAdminDecorator/index.js
 ** module id = 1102
 ** module chunks = 0
 **/